import React, { useState } from "react";
import { Button } from "@material-tailwind/react";
import { addNewUnitApi } from "api/unit";

function NewUnit({ closePopup }) {
  const [unitName, setUnitName] = useState('')

  const handleAddUnit = async () => {
    try {
      await addNewUnitApi(unitName)
      closePopup("Reload");
    }
    catch (err) {
      console.log(err)
    }
  };
  const handleCancelOp = () => {
    closePopup("Close");
  };

  return (
    <form>
      <div className="mt-2 grid grid-cols-1 gap-5 md:grid-cols-3">
        <div>
          <label htmlFor="" className="text-md font-bold text-navy-700">
            Nom de l'unité
          </label>
          <input
            type="text"
            id=""
            placeholder="Nom de l'unité"
            className={`flex w-full items-center justify-center rounded-xl border bg-white/0 p-2 text-sm outline-none`}
            onChange={e => setUnitName(e.target.value)}
          />
        </div>
      </div>

      <div className="mt-5">
        <Button
          variant="gradient"
          color="#236571"
          onClick={() => handleAddUnit()}
          className="mr-1"
        >
          <span>Ajouter</span>
        </Button>
        <Button
          variant="text"
          color="#cf503f"
          onClick={() => handleCancelOp()}
          className="mr-1"
        >
          <span>Annuler</span>
        </Button>
      </div>
    </form>
  );
}

export default NewUnit;
